/**
 * Recording slice - manages recording state for camera/screen/audio flows
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Mode flags
  isRecording: false,
  isCameraEnabled: false,
  isScreenEnabled: false,
  isAudioEnabled: false,
  cameraHasStopped: false,

  // Countdown / timers
  isTimerRunning: false,
  timerValue: 3,
  recordingTime: 0,

  // UI flags
  isScreenRecordReminderVisible: false,
  isCameraRecordingPaused: false,
};

const recordingSlice = createSlice({
  name: 'recording',
  initialState,
  reducers: {
    setIsRecording: (state, action) => {
      state.isRecording = !!action.payload;
    },
    setIsCameraEnabled: (state, action) => {
      state.isCameraEnabled = !!action.payload;
    },
    setIsScreenEnabled: (state, action) => {
      state.isScreenEnabled = !!action.payload;
    },
    setIsAudioEnabled: (state, action) => {
      state.isAudioEnabled = !!action.payload;
    },
    setCameraHasStopped: (state, action) => {
      state.cameraHasStopped = !!action.payload;
    },

    // Countdown / timers
    setIsTimerRunning: (state, action) => {
      state.isTimerRunning = !!action.payload;
    },
    setTimerValue: (state, action) => {
      state.timerValue = Number(action.payload) || 0;
    },
    setRecordingTime: (state, action) => {
      state.recordingTime = Number(action.payload) || 0;
    },

    // UI flags
    setIsScreenRecordReminderVisible: (state, action) => {
      state.isScreenRecordReminderVisible = !!action.payload;
    },
    setIsCameraRecordingPaused: (state, action) => {
      state.isCameraRecordingPaused = !!action.payload;
    },

    resetRecordingState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setIsRecording,
  setIsCameraEnabled,
  setIsScreenEnabled,
  setIsAudioEnabled,
  setCameraHasStopped,
  setIsTimerRunning,
  setTimerValue,
  setRecordingTime,
  setIsScreenRecordReminderVisible,
  setIsCameraRecordingPaused,
  resetRecordingState,
} = recordingSlice.actions;

export default recordingSlice.reducer;


